import React, { useState, useEffect, useContext, useCallback } from "react";
import styled from "styled-components";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { ActionContext } from "context/ActionContext";
import UserService from "services/UserService";
import { getActionPlan, deleteAction } from "services/ConfigServices";
import {
  AutocompleteMultiselectCheckbox,
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
import CustomDeleteDialog from "components/CustomDeleteDialog/CustomDeleteDialog.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import CustomCommentDialog from "components/CustomCommentDialog/CustomCommentDialog.js";
import useActionTable from "./useActionTable.js";

//import "react-table/react-table.css";

// @mui/icons-material
import GetAppIcon from "@mui/icons-material/GetApp";

import Button from "components/CustomButtons/Button.js";
import { getDefaultLibFileName } from "typescript";

const useStyles = makeStyles(styles);

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const RTMaterials = ({ materialId, onMaterialIdChange }) => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [walls, setWalls] = useState([]);
  const [editableRowId, setEditableRowId] = useState(false);
  const [editedWalls, setEditedWalls] = useState([]);

  const [newData, setNewData] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

  const handleAutocompleteChange = useCallback(
    (newValue, id) => {
      console.log(newValue, id);
      let newArray = [...newValue];

      let copyOfWalls = [...action.parameters?.impact?.walls];

      let newObj = newData.find((x) => x.id == id);

      const newKeys = { id: "uuid" };

      let replacedUuidWithIdName = renameKeys(newObj, newKeys);

      newArray.map((wall) => {
        let index = wall.materials.findIndex((x) => x.uuid == id);
        index === -1 && wall.materials.push(replacedUuidWithIdName);
      });

      console.log(newObj, replacedUuidWithIdName, newArray);

      let deletedObj = [];

      let copyOfAction = { ...action };

      if (newArray.length < copyOfWalls.length) {
        deletedObj = copyOfAction.parameters?.impact?.walls.filter(
          ({ id: id1 }) => !newArray.some(({ id: id2 }) => id2 === id1)
        );
        const deleteObj = deletedObj[0]?.materials.filter(
          (obj) => obj.uuid != id
        );

        deletedObj[0].materials = deleteObj;
      }

      const findNewItem = (oldWall) =>
        deletedObj.find((wall) => wall.id === oldWall.id);

      let deletedResult = copyOfWalls.map((wall) => findNewItem(wall) || wall);

      setAction((prevState) => ({
        ...prevState,
        parameters: {
          ...prevState.parameters,
          impact: {
            ...prevState.parameters.impact,
            walls:
              newArray.length > copyOfWalls.length ? newArray : deletedResult,
          },
        },
      }));

      
    },
    [editableRowId]
  );

  function renameKeys(obj = {}, newKeys = "") {
    const keyValues = Object.keys(obj).map((key) => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  function indexFinder(rowId) {
    //console.log(rowId, newData);
    const indexOfId = newData.findIndex((obj) => obj.id == rowId);

    return indexOfId;
  }

  function getIdNameWalls(array = [], id) {
    let values = [];

    for (let i = 0; i < array.length; i++) {
      values.push(associatedwallsList([array[i]], id));
    }
    let filteredValues = values.filter((n) => n);

    let wallObjects = [];

    for (let i = 0; i < filteredValues.length; i++) {
      wallObjects.push(
        action.parameters?.impact?.walls.find(
          (wall) => wall.id == filteredValues[i]
        )
      );
    }

    return wallObjects;
  }

  function associatedwallsList(array = [], id, parentId) {
   // console.log(array, id, parentId);
    return array.some(
      (o) =>
        o.id === id ||
        (o.materials &&
          (parentId = associatedwallsList2(o.materials, id, o.id)) !== null)
    )
      ? parentId
      : null;
  }

  function associatedwallsList2(array = [], id, parentId) {
   // console.log(array, id, parentId);
    return array.some(
      (o) =>
        o.uuid === id ||
        (o.materials &&
          (parentId = associatedwallsList2(o.materials, id, o.uuid)) !== null)
    )
      ? parentId
      : null;
  }

  const handleCheckboxChange = (e, key, id) => {
    let copyOfWalls = [...action.parameters?.impact?.[key]];

    //console.log("handleCheckboxChange",e,key,id);
    let newMaterial = newData.find((x) => x.id == id);

    const newKeys = { id: "uuid" };

    let replacedUuidWithIdName = renameKeys(newMaterial, newKeys);

    let wallId = e.props.value;

    let clickedWall = copyOfWalls.find((wall) => wall.id == wallId);

    let index = clickedWall.materials.findIndex((x) => x.uuid == id);
    index === -1
      ? clickedWall.materials.push(replacedUuidWithIdName)
      : clickedWall.materials.splice(index, 1);
      //console.log("clickedWall",clickedWall.materials);
    let foundIndex = copyOfWalls.findIndex((x) => x.id == clickedWall.id);
    copyOfWalls[foundIndex] = clickedWall;

    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters.impact,
          walls: copyOfWalls,
        },
      },
    }));
    onMaterialIdChange(clickedWall.id);
  };
  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "category",
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => row.walltype,
      sortable: true,
    },
    {
      name: "Épaisseur",
      selector: (row) => row.thickness,
      sortable: true,
      maxWidth: "7rem",
    },
    {
      name: "RTH",
      selector: (row) => row.thermicalresistance,
      sortable: true,
      maxWidth: "6rem",
    },
    {
      name: "U matériau",
      selector: (row) => row.umaterial,
      sortable: true,
      maxWidth: "7rem",
    },
    {
      name: "Cloisons associées",
      selector: (row) => row.umaterial,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <MultiselectCheckbox
            selected={
              getIdNameWalls(action.parameters?.impact?.walls, row.id) || []
            }
            list={action.parameters?.impact?.walls || []}
            handleChange={(_, e) => handleCheckboxChange(e, "walls", row.id)}
            disabledAll
            //primary=" Consommation totale"
          />
        ) : (
          // <AutocompleteMultiselectCheckbox
          //   //inputTitle={actionVar[params].targetedenergy}
          //   //selected={newData?.[indexFinder(row.id)]?.["associatedwalls"] || []}
          //   selected={
          //     getIdNameWalls(action.parameters?.impact?.walls, row.id) || []
          //   }
          //   disabled
          // />
          <GroupCell>
            {getIdNameWalls(action.parameters?.impact?.walls, row.id)?.map(
              (usage) => {
                return <Chip label={usage.name} key={usage.id} />;
              }
            )}
          </GroupCell>
        ),
    },
    {
      name: "Coût unitaire d'ajout (€/m2)",
      selector: (row) => row.unitcost,
      sortable: true,
      maxWidth: "7rem",
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].unitcost}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="unitcost"
          />
        ) : (
          row.unitcost
        ),
    },

    actionplanupdate && {
      name: "",
      sortable: false,
      width: "4rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer">
              <Button
                onClick={editableRowId === row.id ? editCleared(row) : editEnabled(row)}
                color={editableRowId === row.id ? "info" : "success"}
                className={classes.actionButton}
              >
                {editableRowId === row.id ? (
                  <CheckIcon fontSize="large" />
                ) : (
                  <EditIcon fontSize="large" />
                )}
              </Button>
            </Tooltip>
            {/*editableRowId === row.id && (
              <Tooltip title="Annuler le changement">
                <Button
                  onClick={editCleared(row)}
                  color={"danger"}
                  className={classes.actionButton}
                >
                  <ClearIcon fontSize="large" />
                </Button>
              </Tooltip>
            )*/}
          </div>
        </>
      ),
    },
  ];

  // const deleteActionSelected = (row) => async () => {
  //   let obj = dataActions.find((o) => o.id === row.id);
  //   let idSelected = obj.id;
  //   console.log(idSelected);
  //   let url = deleteAction(idSelected);
  //   axios
  //     .delete(url, {
  //       headers: {
  //         Authorization: `Bearer ${UserService.getToken()}`,
  //       },
  //     })
  //     .then((res) => {
  //       if (res.status == 200)
  //         NotificationManager.success("Le scénario a bien été supprimé");
  //       else NotificationManager.error("Un problème est survenu");
  //     });

  //   axios
  //     .get(getActionPlan(planActionId), {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${UserService.getToken()}`,
  //       },
  //     })
  //     .then((response) => {
  //       console.log(response);
  //       //setActionPlans(response.data || []);
  //       refreshTable();
  //     });
  // };

  const handleIdChange = (materialId) => {
    let values = [];

    let array = action.parameters?.impact?.walls;

    for (let i = 0; i < array.length; i++) {
      values.push(associatedwallsList([array[i]], materialId));
    }
    let wallsIds = values.filter((n) => n);

    onMaterialIdChange({ materialId, wallsIds });
    console.log({ materialId, wallsIds });
  };

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
  };

  const editEnabled = (row) => async () => {
     console.log("edit is clicked", row);

     //editableRowId !== row.id && editableRowId?  handleIdChange(editableRowId) :{};

    // editableRowId === row.id
    //   ? setEditableRowId(null)
    //   : setEditableRowId(row.id);
    setEditableRowId(row.id);
  };

  const editCleared = (row) => async () => {
    console.log("edit is cleared", row.id);

   // editableRowId === row.id ? handleIdChange(row.id) : handleIdChange(null);
   // editableRowId === row.id ? handleIdChange(row.id) : handleIdChange(null);
    setEditableRowId(null);
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Liste de matériaux"
        noDataComponent="Selectionner des parois contenant des matériaux ou ajouter un nouveau matériau"
        columns={columns}
        persistTableHead
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        dense
        //selectableRows
        //onSelectedRowsChange={handleSelectedChange}
        //contextMessage={contextMessage}
        {...gridState}
      />
    </>
  );
};

export default RTMaterials;
